import { InnerBlocks, useBlockProps } from "@wordpress/block-editor";

export default function Save({ attributes }) {
    const blockProps = useBlockProps.save({
        className: 'wp-block-puroclean-tabs'
    });

    return (
        <div {...blockProps}>
            <div className="tabs-container" data-tabs>
                <InnerBlocks.Content />
            </div>
        </div>
    );
}
